export default __webpack_public_path__ + "static/media/SWT0390.34I-21673_-16355_0.20142d57.jpg";